module.exports = __webpack_public_path__ + "img/nav-design-classic@2x.de79223.webp";